import React from "react";

/* ── Status config map ── */
const STATUS_CONFIG: Record<string, { bg: string; border: string; text: string; dot: string }> = {
  APPROVED:        { bg: "linear-gradient(135deg,#f0fdf4,#dcfce7)", border: "#bbf7d0", text: "#15803d", dot: "#16a34a" },
  CAPTURED:        { bg: "linear-gradient(135deg,#f0fdf4,#dcfce7)", border: "#bbf7d0", text: "#15803d", dot: "#16a34a" },
  CREATED:         { bg: "linear-gradient(135deg,#f0fdf4,#dcfce7)", border: "#bbf7d0", text: "#15803d", dot: "#16a34a" },
  REFUNDED:        { bg: "linear-gradient(135deg,#eff6ff,#dbeafe)", border: "#bfdbfe", text: "#1d4ed8", dot: "#2563eb" },
  AUTHORIZED:      { bg: "linear-gradient(135deg,#fff7ed,#ffedd5)", border: "#fed7aa", text: "#c2410c", dot: "#ea580c" },
  PENDING:         { bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", border: "#fde68a", text: "#b45309", dot: "#d97706" },
  ERRORED:         { bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", border: "#fde68a", text: "#b45309", dot: "#d97706" },
  ALERTED:         { bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", border: "#fde68a", text: "#b45309", dot: "#d97706" },
  HELD:            { bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", border: "#fde68a", text: "#b45309", dot: "#d97706" },
  DUPLICATE:       { bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", border: "#fde68a", text: "#b45309", dot: "#d97706" },
  DISPUTE:         { bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", border: "#fde68a", text: "#b45309", dot: "#d97706" },
  DECLINED:        { bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)", border: "#fecdd3", text: "#be123c", dot: "#e11d48" },
  CANCELLED:       { bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)", border: "#fecdd3", text: "#be123c", dot: "#e11d48" },
  FAILED:          { bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)", border: "#fecdd3", text: "#be123c", dot: "#e11d48" },
  REJECTED:        { bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)", border: "#fecdd3", text: "#be123c", dot: "#e11d48" },
  CHARGEBACK:      { bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)", border: "#fecdd3", text: "#be123c", dot: "#e11d48" },
  "REFUND DECLINED": { bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)", border: "#fecdd3", text: "#be123c", dot: "#e11d48" },
};

const DEFAULT_CONFIG = { bg: "#f8fafc", border: "#e2e8f0", text: "#64748b", dot: "#94a3b8" };

const StatusRender = ({ status, value }: { status: string; value: string }) => {
  const cfg = STATUS_CONFIG[status] ?? DEFAULT_CONFIG;

  if (!status) return null;

  return (
    <span
      className="txn-status-badge"
      style={{ background: cfg.bg, border: `1.5px solid ${cfg.border}`, color: cfg.text }}
    >
      <span className="txn-status-dot" style={{ background: cfg.dot }} />
      {value}
      <style>{`
        .txn-status-badge { display:inline-flex; align-items:center; gap:5px; padding:4px 10px; border-radius:8px; font-size:11px; font-weight:700; white-space:nowrap; text-transform:uppercase; letter-spacing:0.3px; font-family:'Plus Jakarta Sans',sans-serif; }
        .txn-status-dot { width:6px; height:6px; border-radius:50%; flex-shrink:0; }
      `}</style>
    </span>
  );
};

export default StatusRender;